import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import styles from './collapsible-section.module.scss';

type CollapsibleSectionProps = {
	id: string;
	stepNumber: number;
	title: string;
	description?: string;
	summary?: string;
	complete: boolean;
	open: boolean;
	onToggle: () => void;
	children: React.ReactNode;
};

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
	id,
	stepNumber,
	title,
	description,
	summary,
	complete,
	open,
	onToggle,
	children,
}) => {
	return (
		<section
			className={`${styles.section} ${open ? styles.open : ''} ${
				complete ? styles.complete : ''
			}`}
		>
			<h3 className={styles['header-wrapper']}>
				<button
					type="button"
					className={styles.header}
					onClick={onToggle}
					aria-expanded={open}
					aria-controls={`${id}-content`}
					id={`${id}-header`}
				>
					<span className={styles.badge} aria-hidden="true">
						{complete ? <CheckIcon size={16} /> : stepNumber}
					</span>
					<span className={styles['header-text']}>
						<span className={styles.title}>{title}</span>
						{!open && summary && (
							<span className={styles.summary}>{summary}</span>
						)}
						{open && description && (
							<span className={styles.summary}>{description}</span>
						)}
					</span>
					<ChevronDownIcon
						size={20}
						className={styles.chevron}
						aria-hidden="true"
					/>
				</button>
			</h3>
			<div
				id={`${id}-content`}
				role="region"
				aria-labelledby={`${id}-header`}
				className={styles.content}
				hidden={!open}
			>
				<div className={styles['content-inner']}>{children}</div>
			</div>
		</section>
	);
};
